var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import gallary from "../../../../assets/images/features/BasicProfile/galleryImg.svg";
import camera from "../../../../assets/images/features/BasicProfile/cameraImg.svg";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { useSelector } from "react-redux";
import di from "../di/servicelocator";
import Toaster from "@frameworks/shared-library/components/Toast/Toast";
import _, { reject } from "underscore";
import { accountDetails } from "@mainDi/webDi";
var EditProfile = function (props) {
    var _a, _b;
    var device = DeviceContext();
    var accData = JSON.parse(localStorage.getItem("acc_data"));
    var _c = __read(React.useState(true), 2), isImageValid = _c[0], setIsImageValid = _c[1];
    var _d = __read(useState(""), 2), docFile = _d[0], setDocFile = _d[1];
    var accountCode = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.accountCode; }, _.isEqual);
    var getprofilepicDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, accCode, accTyp, payload;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getPreferedAccountCodeID())];
                case 1:
                    _a = _b.sent(), accCode = _a.accCode, accTyp = _a.accTyp;
                    payload = { acCode: accCode };
                    di.basicProfile.getProfilePicData(payload);
                    return [2 /*return*/];
            }
        });
    }); };
    var getallprofilepicDetails = useSelector(function (state) { return state.BasicProfile.GetProfilePicReducer; }
    // _.isEqual
    );
    var onSelectFile = function (e) {
        var selectedFiles = e.target.files;
        if (selectedFiles && selectedFiles.length > 0) {
            window.URL.createObjectURL(selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles[0]);
            var fileTypes = ["jpeg", "jpg", "png"];
            var file1_1 = selectedFiles[0];
            var fileType = fileTypes.find(function (val) { return file1_1.type.split("/")[1] === val; });
            var fileSize = file1_1.size;
            if (fileSize <= 5242880) {
                if (fileTypes.includes(fileType)) {
                    setIsImageValid(true);
                    var reader_1 = new FileReader();
                    reader_1.readAsDataURL(selectedFiles[0]);
                    reader_1.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var base64Image, _a, accCode, accTyp;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    setDocFile(file1_1.name);
                                    base64Image = reader_1.result;
                                    return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getPreferedAccountCodeID())];
                                case 1:
                                    _a = _b.sent(), accCode = _a.accCode, accTyp = _a.accTyp;
                                    di.basicProfile
                                        .SaveProfilePicData({
                                        savepicbody: {
                                            userId: props === null || props === void 0 ? void 0 : props.getprofiledatauserid,
                                            accountCode: accCode,
                                            profileImageByte: base64Image.split(",")[1],
                                            imageName: file1_1.name,
                                        },
                                    })
                                        .then(function (res) {
                                        if (res) {
                                            getprofilepicDetails();
                                            props === null || props === void 0 ? void 0 : props.setShowToast(true);
                                            (props === null || props === void 0 ? void 0 : props.setToastMsg) &&
                                                (props === null || props === void 0 ? void 0 : props.setToastMsg("Upload Successfully"));
                                            props === null || props === void 0 ? void 0 : props.seteditProfile(false);
                                        }
                                    })
                                        .catch(function (err) {
                                        (props === null || props === void 0 ? void 0 : props.setToastMsg) &&
                                            (props === null || props === void 0 ? void 0 : props.setToastMsg("something went wrong"));
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                }
                else {
                    setIsImageValid(false);
                    alert("Invalid image,Please select jpg,jpeg,png type image. !!!");
                }
            }
            else {
                setIsImageValid(false);
                return alert("Image size should be less that 5MB. !!!!");
            }
        }
    };
    var _e = __read(useState(""), 2), source = _e[0], setSource = _e[1];
    var handleCapture = function (target) {
        var selectedFiles = target.files;
        if (target.files) {
            if (target.files.length !== 0) {
                var file_1 = target.files[0];
                var newUrl = URL.createObjectURL(file_1);
                setSource(newUrl);
                var reader_2 = new FileReader();
                reader_2.readAsDataURL(selectedFiles[0]);
                reader_2.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var base64Image, _a, accCode, accTyp;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                setDocFile(file_1.name);
                                base64Image = reader_2.result;
                                return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getPreferedAccountCodeID())];
                            case 1:
                                _a = _b.sent(), accCode = _a.accCode, accTyp = _a.accTyp;
                                di.basicProfile
                                    .SaveProfilePicData({
                                    savepicbody: {
                                        userId: props === null || props === void 0 ? void 0 : props.getprofiledatauserid,
                                        accountCode: accCode,
                                        profileImageByte: base64Image.split(",")[1],
                                        imageName: file_1.name,
                                    },
                                })
                                    .then(function (res) {
                                    if (res) {
                                        getprofilepicDetails();
                                        props.seteditProfile(false);
                                    }
                                });
                                return [2 /*return*/];
                        }
                    });
                }); };
            }
        }
    };
    var removeProfilePic = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, accCode, accTyp, reqobj;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getPreferedAccountCodeID())];
                case 1:
                    _a = _b.sent(), accCode = _a.accCode, accTyp = _a.accTyp;
                    reqobj = {
                        savepicbody: {
                            userId: props === null || props === void 0 ? void 0 : props.getprofiledatauserid,
                            accountCode: accCode,
                            profileImageByte: "",
                            imageName: "",
                        },
                    };
                    di.basicProfile
                        .DeleteProfilePicData(reqobj)
                        .then(function () {
                        getprofilepicDetails();
                        props.seteditProfile(false);
                    })
                        .catch(function (err) {
                        reject(err);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Toaster, { parentClass: "position-relative margin-toast", show: props === null || props === void 0 ? void 0 : props.showToast, setShow: props === null || props === void 0 ? void 0 : props.setShowToast, position: "middle-center", message: props === null || props === void 0 ? void 0 : props.toastMsg }),
        device && device.isDesktop ? (React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "grid-2 editprofile-section" },
                React.createElement("div", { className: "fileupload-section-ineer editbox-profile text-center" },
                    React.createElement("label", { htmlFor: "feedBackFile", className: "DMSanM_15_500 mb-0 hand-cursor", onClick: function () {
                            props === null || props === void 0 ? void 0 : props.toggleStream();
                            props === null || props === void 0 ? void 0 : props.setIsCanOpen(true);
                            props === null || props === void 0 ? void 0 : props.seteditProfile(false);
                        } },
                        React.createElement("img", { src: camera, alt: "Camera Icon" }),
                        React.createElement("div", { className: "mgt-10 hand_cursor" }, (props === null || props === void 0 ? void 0 : props.streamStarted) ? "Close Camera" : "Open Camera"))),
                React.createElement("div", { className: "fileupload-section-ineer editbox-profile text-center" },
                    React.createElement("input", { type: "file", id: "feedBackFile", onChange: function (e) {
                            onSelectFile(e);
                        }, hidden: true }),
                    React.createElement("label", { htmlFor: "feedBackFile", className: "DMSanM_15_500  mb-0 hand-cursor" },
                        React.createElement("img", { src: gallary }),
                        React.createElement("div", { className: "mgt-10 hand_cursor" }, "Upload From Device"))),
                ((_a = getallprofilepicDetails === null || getallprofilepicDetails === void 0 ? void 0 : getallprofilepicDetails.data) === null || _a === void 0 ? void 0 : _a.imageNm) !== "" && (React.createElement("div", { className: "editbox-profile text-center hand-cursor", onClick: function (e) {
                        removeProfilePic(e);
                        getprofilepicDetails();
                    } },
                    React.createElement("i", { className: "edel-icon-trash txt_bloodRed" }),
                    React.createElement("p", { className: "DMSans_16_500 mgt-10 mb-0 hand_cursor" }, "Delete Photo")))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "Edit-profile-mb" },
                React.createElement("div", { className: "Edit-profile-mb-item" },
                    React.createElement("input", { accept: "image/*", id: "icon-button-file", type: "file", capture: true, hidden: true, onChange: function (e) { return handleCapture(e.target); } }),
                    React.createElement("div", null,
                        React.createElement("img", { src: camera }),
                        React.createElement("label", { htmlFor: "icon-button-file", className: "DMSanM_15_500  mb-0 pdl-15" }, "Open Camera"))),
                React.createElement("div", { className: "Edit-profile-mb-item" },
                    React.createElement("input", { type: "file", id: "feedBackFile", onChange: function (e) {
                            onSelectFile(e);
                        }, hidden: true }),
                    React.createElement("label", { htmlFor: "feedBackFile", className: "DMSanM_15_500  mb-0 hand_cursor" },
                        React.createElement("img", { src: gallary }),
                        React.createElement("span", { className: "mgt-10 pdl-15 hand_cursor" }, "Upload From Device"))),
                ((_b = getallprofilepicDetails === null || getallprofilepicDetails === void 0 ? void 0 : getallprofilepicDetails.data) === null || _b === void 0 ? void 0 : _b.imageNm) !== "" && (React.createElement("div", { className: "Edit-profile-mb-item hand_cursor", onClick: function (e) {
                        removeProfilePic(e);
                        getprofilepicDetails();
                    } },
                    React.createElement("i", { className: "edel-icon-trash txt_bloodRed" }),
                    React.createElement("p", { className: "DMSans_16_500 mgt-10 mb-0 pdl-15 hand_cursor" }, "Delete Photo"))))))));
};
export default EditProfile;
